import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("../views/Dashboard.vue"),
      },
      {
        path: "/buscar",
        name: "Buscar",
        component: () => import("../views/Buscar.vue"),
      },
      {
        path: "/categorias",
        name: "Categorias",
        component: () => import("../views/Categorias.vue"),
      },
      {
        path: "/categoria/:id_categoria",
        name: "Categoria",
        component: () => import("../views/Categoria.vue"),
      },
      /*  {
        path: "/aliado/:id_aliado",
        name: "Aliado",
        component: () => import("../views/Aliado.vue"),
      }, */
      {
        path: "/aliado/:id_aliado",
        name: "Aliado_n",
        component: () => import("../views/Aliado_n.vue"),
      },
      {
        path: "/favoritos",
        name: "Favoritos",
        component: () => import("../views/Favoritos.vue"),
      },
      {
        path: "/perfil",
        name: "Perfil",
        component: () => import("../views/Perfil.vue"),
      },
      {
        path: "/cambiar_clave",
        name: "Cambiar_clave",
        component: () => import("../views/Cambiar_clave.vue"),
      },
      {
        path: "/ciudad",
        name: "Ciudad",
        component: () => import("../views/Ciudad.vue"),
      },
    ],
  },
  {
    path: "/auth",
    name: "Auth",
    component: () => import("../views/Auth.vue"),
  },
  {
    path: "/password_reset",
    name: "Password_reset",
    component: () => import("../views/Password_reset.vue"),
  },
  {
    path: "/password_reset/token/:token",
    name: "Password_reset_token",
    component: () => import("../views/Password_reset_token.vue"),
  },
  {
    path: "/registro",
    name: "Registro",
    component: () => import("../views/Registro.vue"),
  },
  {
    path: "/registro/token/:token",
    name: "Registro_token",
    component: () => import("../views/Registro_token.vue"),
  },
  {
    path: "/leer_qr",
    name: "Leer_qr",
    component: () => import("../views/Leer_qr.vue"),
  },
  {
    path: "/feedback/:id?",
    name: "Feedback",
    component: () => import("../views/Feedback.vue"),
  },
  {
    path: "/error_leer_qr",
    name: "Error_leer_qr",
    component: () => import("../views/Error_leer_qr.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
